import {
    PasswordResetSmsRequestDto,
    PasswordResetEmailRequestDto,
    PasswordVerifySmsRequestDto,
    PasswordVerifyEmailRequestDto,
    PasswordVerifySmsEmailRequestDto,
    PasswordChangeViaTokenRequestDto
} from "../models/Verification.model";

function tokenDto(token: string): PasswordVerifyEmailRequestDto {
    return {
        token: token
    }
}

function emailDto(email: string, origin: string): PasswordResetEmailRequestDto {
    return {
        email: email,
        origin: origin,
    }
}

function getPhoneNumberDto(phoneNumber: string): PasswordResetSmsRequestDto {
    const formattedPhoneNumber = phoneNumber.replace(/ /g, '')
    return {
        phoneNumber: formattedPhoneNumber
    }
}

function getPhoneVerificationDto(token: string, phoneNumber: string): PasswordVerifySmsRequestDto {
    const formattedPhoneNumber = phoneNumber.replace(/ /g, '')
    return {
        token: token,
        phoneNumber: formattedPhoneNumber
    }
}

function getPhoneEmailVerificationDto(token: string, phoneNumber: string, email: string): PasswordVerifySmsEmailRequestDto {
    const formattedPhoneNumber = phoneNumber.replace(/ /g, '')
    return {
        token: token,
        phoneNumber: formattedPhoneNumber,
        email: email
    }
}

function getSetPswDto(token: string, type: "SMS" | "EMAIL", userName: string, password: string, phoneNumber?: string): PasswordChangeViaTokenRequestDto {
    return {
        token: token,
        type: type,
        username: userName,
        password: password,
        phoneNumber: phoneNumber
    }
}

export {
    tokenDto,
    emailDto,
    getPhoneNumberDto,
    getPhoneVerificationDto,
    getPhoneEmailVerificationDto,
    getSetPswDto
}
